import { render, staticRenderFns } from "./dashboard-container.vue?vue&type=template&id=2dcf4798&lang=pug"
import script from "./dashboard-container.js?vue&type=script&lang=js&external"
export * from "./dashboard-container.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-container.vue?vue&type=style&index=0&id=2dcf4798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports